<template>
  <table class="table is-fullwidth" ref="documentsTable">
    <thead>
      <tr class="has-background-light">
        <th>#</th>
        <th style="width: 100%">{{ $t("expressions.fileName") }}</th>
        <th>{{ $t("common.type") }}</th>
        <th>{{ $t("common.comment") }}</th>
        <th>{{ $t("common.date") }}</th>
        <th>{{ $t("common.action") }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="!documents.length">
        <td :colspan="6" class="has-text-centered">
          {{ $t("common.noRecords") }}
        </td>
      </tr>
      <tr
        v-for="(document, idx) in documents"
        :key="'document_' + document.id + '_' + idx"
      >
        <td>{{ idx + 1 }}</td>
        <td style="width: 100%">{{ document.filename }}</td>
        <td style="text-wrap: nowrap">
          {{ document.type && document.type.name }}
        </td>
        <td>
          <div class="comment-container">
            <div v-if="document.editingComment" class="comment-edit">
              <textarea
                class="textarea"
                v-model="document.comment"
                rows="2"
                @input="autoResizeTextarea"
                ref="commentTextarea"
              ></textarea>
              <div class="comment-actions">
                <button
                  class="button is-small is-primary"
                  @click="saveComment(document)"
                >
                  <i class="fa fa-save"></i> {{ $t("common.save") }}
                </button>
                <button
                  class="button is-small"
                  @click="cancelEditComment(document)"
                >
                  {{ $t("common.cancel") }}
                </button>
              </div>
            </div>
            <div v-else class="comment-display">
              <p v-if="document.comment" class="comment-text">
                {{ document.comment }}
              </p>
              <p v-else class="comment-empty"></p>
              <button
                class="button is-small"
                :class="document.comment ? '' : 'is-success'"
                @click="startEditComment(document)"
              >
                <i
                  :class="document.comment ? 'fa fa-pencil' : 'fa fa-plus'"
                ></i>
              </button>
            </div>
          </div>
        </td>
        <td>{{ document.createdAt | reverseDate }}</td>
        <td>
          <div class="document-actions">
            <form
              class="inline-form"
              method="POST"
              target="_blank"
              :action="`${API}/document/${document.id}`"
            >
              <button class="button is-primary is-small" type="submit">
                <i class="fa fa-download"></i>
                {{ $t("common.download") }}
              </button>
              <input type="hidden" name="token" :value="authToken" />
            </form>
            <button
              v-if="deletable"
              class="button is-danger is-small"
              @click="deleteDocument(document.id)"
            >
              <i class="fa fa-trash"></i>
              {{ $t("common.delete") }}
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<style scoped>
.document-actions {
  display: flex;
  flex-direction: column;
  button:last-child {
    margin-top: 8px;
  }
}

.comment-container {
  width: 100%;
}
.comment-edit {
  width: 100%;
}
.comment-edit textarea {
  border: 1px solid #dbdbdb;
  resize: vertical;
  min-height: 30px;
  overflow-y: hidden;
  margin-top: 0px;
  width: 250px;
}
.comment-actions {
  display: flex;
  margin-top: 5px;
}
.comment-actions button:not(:first-child) {
  margin-left: 5px;
}

.comment-actions button > i {
  margin-right: 7px;
}
.comment-display {
  display: flex;
}
.comment-text {
  margin-right: 10px;
  width: 250px;
  flex: 1;
  word-break: break-word;
}
.comment-empty {
  color: #999;
  font-style: italic;
  margin-right: 10px;
  flex: 1;
}
</style>
<script>
import axios from "axios";
export default {
  name: "documents-table",
  props: {
    objectId: [String, Number],
    objectName: String,
    deletable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      documents: [],
      API: axios.defaults.baseURL,
      authToken: this.$store.getters["auth/getToken"],
    };
  },
  computed: {},
  mounted() {
    this.fetchDocuments();
  },
  methods: {
    fetchDocuments() {
      axios
        .get(`/documents?entity=${this.objectName}&id=${this.objectId}`)
        .then((res) => {
          this.documents = res.data;
        });
    },
    deleteDocument(documentId) {
      return this.$awn.confirm(this.$t("expressions.deleteDocument"), () =>
        axios.delete(`/document/${documentId}`).then((response) => {
          if (response.data.success) {
            this.fetchDocuments();
          }
        })
      );
    },
    updateComment(documentId, comment) {
      const formData = new FormData();
      formData.append("token", this.authToken);
      formData.append("comment", comment || "");

      axios
        .put(`/document/${documentId}`, formData)
        .then((response) => {
          if (response.data && response.data.success) {
            this.$awn.success(this.$t("common.commentUpdated"));
          }
        })
        .catch((error) => {
          console.error("Comment update error:", error.response || error);
          this.$awn.warning(this.$t("common.commentUpdateFailed"));
          this.fetchDocuments();
        });
    },
    autoResizeTextarea(event) {
      const textarea = event.target;
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    },
    startEditComment(document) {
      document.originalComment = document.comment;
      this.$set(document, "editingComment", true);
      this.$nextTick(() => {
        const textarea = this.$refs.commentTextarea;
        if (textarea && textarea.length > 0) {
          textarea[0].focus();
        }
      });
    },
    cancelEditComment(document) {
      document.comment = document.originalComment;
      this.$set(document, "editingComment", false);
    },
    saveComment(document) {
      this.updateComment(document.id, document.comment);
      this.$set(document, "editingComment", false);
    },
  },
  watch: {
    "documents.length": function (v) {
      this.$emit("updated", v);
    },
  },
};
</script>
